import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AngularFireAuthGuard, loggedIn, isNotAnonymous, hasCustomClaim, redirectUnauthorizedTo, redirectLoggedInTo, customClaims } from '@angular/fire/auth-guard';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { CargaArchivosComponent } from './carga-archivos/carga-archivos.component';
import { SimcardsComponent } from './simcards/simcards.component';
import { VendedoresComponent } from './vendedores/vendedores.component';
import { pipe } from 'rxjs';
import { map } from 'rxjs/operators';
import { PuntosVentaComponent } from './puntos-venta/puntos-venta.component';
import { TropasComponent } from './tropas/tropas.component';
import { VentasTropasComponent } from './ventas-tropas/ventas-tropas.component';
import { PagosComponent }  from './pagos/pagos.component';
import { PortabilidadesComponent } from './portabilidades/portabilidades.component';
import { VentasFijasComponent } from './ventas-fijas/ventas-fijas.component';
import { ValidacionesComponent } from './validaciones/validaciones.component';
import { SolicitudesNipComponent } from './solicitudes-nip/solicitudes-nip.component';



const userHasRole = (roles: string[]) => pipe( customClaims, map( claims => claims.hasOwnProperty("rol") && roles.indexOf( claims["rol"] ) != -1 ) );

const redirectToLogin  = () => redirectUnauthorizedTo(['login']);
const redirectToHome   = () => redirectLoggedInTo(['']);
const userHasRoleAdmin = () => userHasRole(['administrador']);
const userHasRoleCtrl  = () => userHasRole(['administrador','controller']);
const userHasRoleBack  = () => userHasRole(['administrador','backoffice']);
//const loggedInUser    = () => loggedIn();



const routes: Routes = [
  { path: '',                        component: HomeComponent,                   canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectToLogin} },
  { path: 'login',                   component: LoginComponent,                  canActivate: [AngularFireAuthGuard], data: {authGuardPipe: redirectToHome} },
  { path: 'usuarios',                component: UsuariosComponent,               canActivate: [AngularFireAuthGuard], data: {authGuardPipe: userHasRoleAdmin}},  
  { path: 'carga-archivos',          component: CargaArchivosComponent,          canActivate: [AngularFireAuthGuard], data: {authGuardPipe: userHasRoleAdmin}},  
  { path: 'puntos-venta',            component: PuntosVentaComponent,            canActivate: [AngularFireAuthGuard], data: {authGuardPipe: userHasRoleAdmin}},    
  { path: 'simcards',                component: SimcardsComponent,               canActivate: [AngularFireAuthGuard], },
  { path: 'ventas-tropas',           component: VentasTropasComponent,           canActivate: [AngularFireAuthGuard], data: {authGuardPipe: userHasRoleBack}},
  { path: 'validaciones',            component: ValidacionesComponent,           canActivate: [AngularFireAuthGuard], data: {authGuardPipe: userHasRoleBack}},
  { path: 'solicitudes-nip',         component: SolicitudesNipComponent,         canActivate: [AngularFireAuthGuard], data: {authGuardPipe: userHasRoleBack}},
  { path: 'ventas-fijas',            component: VentasFijasComponent,            canActivate: [AngularFireAuthGuard], data: {authGuardPipe: userHasRoleCtrl}},  
  { path: 'vendedores',              component: VendedoresComponent,             canActivate: [AngularFireAuthGuard], data: {authGuardPipe: userHasRoleAdmin}},
  { path: 'tropas',                  component: TropasComponent,                 canActivate: [AngularFireAuthGuard], data: {authGuardPipe: userHasRoleAdmin}},
  { path: 'pagos',                   component: PagosComponent,                  canActivate: [AngularFireAuthGuard], data: {authGuardPipe: userHasRoleCtrl}},
  { path: 'portabilidades',          component: PortabilidadesComponent,         canActivate: [AngularFireAuthGuard], data: {authGuardPipe: userHasRoleAdmin}},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
